import { forwardRef, memo, MouseEventHandler } from "react";
import classnames from "classnames";

import { ReactComponent as Show } from "./icons/eye.svg";
import { ReactComponent as Hide } from "./icons/eye-off.svg";

import styles from "./style.module.scss";

type EyeButtonProps = {
  onClick?: MouseEventHandler<HTMLButtonElement>,
  disabled?: boolean,
  isShownPassword?: boolean
}

export const EyeButton = memo<EyeButtonProps>(forwardRef<HTMLButtonElement, EyeButtonProps>((
  { isShownPassword, ...props }, ref) =>
  (
    <button
      ref={ref}
      className={classnames(styles.eyeBtn)}
      type="button"
      {...props}
    >
      {isShownPassword ? <Show /> : <Hide />}
    </button>
  )));


